<template>
  <el-aside width="200px" class="aside">
    <!-- 顶部居中大 LOGO（占位） -->
    <div class="logo-wrap">
      <!-- use public/logo.png from project public folder; use BASE_URL so it works when deployed under a subpath -->
      <img class="logo-img" :src="logoUrl" alt="LOGO" />
    </div>

    <!-- 原品牌信息整体下移 -->
    <div class="brand">
      <div class="brand-title">航小梦国旅</div>
      <div class="brand-sub">火箭发射观礼平台</div>
      <div class="brand-sub2">游客信息管理系统</div>
      <div class="brand-user">
        当前用户：<span class="user-name">{{ currentUserText }}</span>
      </div>
    </div>

    <el-menu
      class="menu"
      :default-active="activeMenu"
      background-color="#1a1d22"
      text-color="#cfd3dc"
      active-text-color="#ffffff"
      @select="onSelect"
    >
      <el-menu-item v-if="can('visitor-input')" index="1">
        <i class="el-icon-user"></i>
        <span slot="title">游客信息录入</span>
      </el-menu-item>
      <el-menu-item v-if="can('visitor-list')" index="2">
        <i class="el-icon-document"></i>
        <span slot="title">游客信息表</span>
      </el-menu-item>
      <el-menu-item v-if="can('ticket-verify')" index="3">
        <i class="el-icon-check"></i>
        <span slot="title">票务核销</span>
      </el-menu-item>
      <el-menu-item v-if="can('finance')" index="4">
        <i class="el-icon-money"></i>
        <span slot="title">财务汇算</span>
      </el-menu-item>
      <el-menu-item v-if="can('data-manage')" index="5">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">数据管理</span>
      </el-menu-item>
      <el-menu-item v-if="can('system-settings')" index="6">
        <i class="el-icon-setting"></i>
        <span slot="title">系统设置</span>
      </el-menu-item>
      <el-menu-item index="8">
        <i class="el-icon-switch-button"></i>
        <span slot="title">退出登录</span>
      </el-menu-item>
    </el-menu>

    <div class="aside-footer">© 2026 航小梦国旅 / 版本 2.1.0</div>
  </el-aside>
</template>

<script>
const AUTH_KEY = 'yy_auth'

export default {
  name: 'AppSidebar',
  props: {
    activeMenu: {
      type: String,
      default: '1'
    }
  },
  computed: {
    currentRole() {
      try {
        const raw = localStorage.getItem(AUTH_KEY)
        const auth = raw ? JSON.parse(raw) : null
        const user = auth && auth.user ? auth.user : null
        return (user && user.role) || ''
      } catch (e) {
        return ''
      }
    },
    currentUserText() {
      try {
        const raw = localStorage.getItem(AUTH_KEY)
        const auth = raw ? JSON.parse(raw) : null
        const user = auth && auth.user ? auth.user : null
        const username = (user && user.username) || ''
        const role = (user && user.role) || ''
        return `${username}（${role}）`
      } catch (e) {
        return ''
      }
    }
    ,
    logoUrl() {
      return './logo.png'
    }
  },
  methods: {
    can(key) {
      const role = this.currentRole
      const map = {
        '超级管理员': ['visitor-input', 'visitor-list', 'ticket-verify', 'finance', 'data-manage', 'system-settings'],
        '游客录入员': ['visitor-input', 'visitor-list', 'system-settings'],
        '票务核销员': ['ticket-verify', 'system-settings'],
        '财务人员': ['finance', 'data-manage', 'system-settings'],
        '分销商': ['visitor-input', 'visitor-list', 'system-settings']
      }
      const allowed = map[role] || []
      return allowed.includes(key)
    },
    onSelect(index) {
      this.$emit('update:activeMenu', index)

      if (index === '8') {
        localStorage.removeItem(AUTH_KEY)
        if (this.$route && this.$route.path !== '/login') {
          this.$router.push('/login')
        }
        return
      }

      const map = {
        '1': { path: '/visitor-input', key: 'visitor-input' },
        '2': { path: '/visitor-list', key: 'visitor-list' },
        '3': { path: '/ticket-verify', key: 'ticket-verify' },
        '4': { path: '/finance', key: 'finance' },
        '5': { path: '/data-manage', key: 'data-manage' },
        '6': { path: '/system-settings', key: 'system-settings' }
      }

      const item = map[index]
      if (!item) return

      if (!this.can(item.key)) {
        this.$message && this.$message.error('无权限访问该页面')
        return
      }

      if (item.path && this.$route && this.$route.path !== item.path) {
        this.$router.push(item.path)
      }
    }
  },
 
}
</script>

<style scoped>
.aside {
  background: #1a1d22;
  color: #cfd3dc;
  display: flex;
  flex-direction: column;
}

.logo-wrap {
  padding: 18px 16px 6px;
  display: flex;
  justify-content: center;
}

/* LOGO 占位：后续你有正式图片时，换成 <img> 即可 */
.logo-placeholder {
  width: 140px;
  height: 64px;
  border-radius: 8px;
  border: 2px dashed rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
}

.logo-img {
  width: 180px;
  height: 82px;
  object-fit: contain;
  border-radius: 6px;
}

.brand {
  padding: 8px 12px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  text-align: center;
}

.brand-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.brand-sub {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
}

.brand-sub2 {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
}

.brand-user {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.user-name {
  color: #f6c343;
  font-weight: 700;
}

.menu {
  border-right: none;
  flex: 1;
  margin-top: 14px;
}

/* 当前激活项做成截图那种“蓝色背景 + 左侧黄色条” */
.menu ::v-deep .el-menu-item {
  height: 46px;
  line-height: 46px;
  padding-left: 18px !important;
}

.menu ::v-deep .el-menu-item i {
  margin-right: 10px;
  font-size: 16px;
}

.menu ::v-deep .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}

.menu ::v-deep .el-menu-item.is-active {
  background: #1f7ae0 !important;
  color: #fff !important;
  position: relative;
}

.menu ::v-deep .el-menu-item.is-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #f6c343;
}

.menu ::v-deep .el-menu-item.is-active i {
  color: #fff !important;
}

.aside-footer {
  padding: 12px 16px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  text-align: center;
}
</style>
